import axios from 'axios';
import { $, endPoint, findTarget, dataExist } from '../utils/Utils';
import cart from './cart';

const form = (() => {
  const triggers = [...$('.js-form')];
  const formErrorCN = '.js-formErrors';
  const formSuccessCN = '.js-formSuccess';

  const updateSubmitBtn = (t, status = 'processing') => {
    const submitBtn = t.querySelector('[type="submit"]');

    if (submitBtn) {
      let txt;
      submitBtn.classList.remove('-progress');

      switch (status) {
        case 'initial':
          submitBtn.removeAttribute('disabled');
          txt = submitBtn.dataset.initial;
          break;
        case 'error':
          submitBtn.removeAttribute('disabled');
          txt = submitBtn.dataset.error;
          break;
        case 'done':
          txt = submitBtn.dataset.done;
          break;
        default:
          submitBtn.setAttribute('disabled', true);
          submitBtn.classList.add('-progress');
          txt = submitBtn.dataset.processing;
          break;
      }

      submitBtn.textContent = txt;
    }
  };

  const formError = {
    reset(t) {
      const $errors = t.querySelector(formErrorCN);

      if ($errors) {
        $errors.classList.remove('-show');
        $errors.innerHTML = '';
      }
    },
    handle(t, arr) {
      const $errors = t.querySelector(formErrorCN);

      if ($errors) {
        $errors.innerHTML = arr.map(err => `<li>${err.message}</li>`).join('');
        $errors.classList.add('-show');
      }
    },
  };

  // const resetForm = (t, $s) => {
  //   setTimeout(() => {
  //     t.reset();
  //     // reboot select component
  //     select.reboot(t);
  //     updateSubmitBtn(t, 'initial');
  //     // hide success message
  //     $s.classList.remove('-show');
  //   }, 5000);
  // };

  const handleSuccess = (t) => {
    const $success = t.querySelector(formSuccessCN);

    if ($success) {
      $success.classList.add('-show');
    }

    updateSubmitBtn(t, 'done');
    // resetForm(t, $success);
  };

  const handleCheckoutSuccess = (t) => {
    const target = findTarget({ element: t, parent: 'js-formCheckoutParent', target: 'js-formCheckoutSuccess' });

    updateSubmitBtn(t, 'done');
    // hide form
    t.classList.add('-hide');
    // show thank you message
    target.classList.remove('-hide');
    // clear cookies
    cart.reset();
  };

  const handleSubmit = (e, trigger) => {
    const formData = new FormData(trigger);

    e.preventDefault();

    // deal with Submit button
    updateSubmitBtn(trigger);

    // hide previous error message
    formError.reset(trigger);

    axios
      .post(endPoint[trigger.dataset.form], formData)
      .then(() => { // response
        if (trigger.classList.contains('js-formCheckout')) {
          handleCheckoutSuccess(trigger);
        } else {
          handleSuccess(trigger);
        }
      })
      .catch((error) => {
        // Object.keys(obj).length === 0 && obj.constructor === Object
        // show correct message on submit button
        updateSubmitBtn(trigger, 'error');

        // show error message
        if (dataExist(error, 'response')) {
          if (dataExist(error.response, 'data')) {
            formError.handle(trigger, error.response.data.errors);
          }
        }
      });
  };

  const build = () => {
    triggers.forEach((trigger) => {
      trigger.addEventListener('submit', e => handleSubmit(e, trigger));
    });
  };

  const init = () => {
    if (triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();


export default form.init();



// WEBPACK FOOTER //
// ./components/form.js